import {ExpandMore} from "@mui/icons-material";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Grid,
    TextField,
} from "@mui/material";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {useHasScope} from "../../../../../../config/globalConfig";
import {THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL} from "../../../../component/utils/AuthConstants";

const CustomerDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(true);
    const navigate = useNavigate();
    const customerDetailsObject = props.customerDetailsObject;
    const id = props.id;
    const hasScope = useHasScope;
    return (
        <Accordion defaultExpanded onChange={(_e, expanded) => {
            setIsExpanded(expanded);
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("customerRADetails.customerDetails")}
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="firstName"
                            value={customerDetailsObject?.firstName}
                            label={t("customerDetails.firstName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="lastName"
                            value={customerDetailsObject?.lastName}
                            label={t("customerDetails.lastName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="birthDate"
                            value={customerDetailsObject?.birthDate ? dayjs(customerDetailsObject.birthDate).format("L") : ""}
                            label={t("customerDetails.birthDate")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="birthPlace"
                            value={customerDetailsObject?.birthPlace?.description}
                            label={t("customerDetails.birthPlace")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="country"
                            value={customerDetailsObject?.birthNation?.description}
                            label={t("customerDetails.country")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="taxCode"
                            value={customerDetailsObject?.fiscalCode}
                            label={t("customerDetails.taxCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="addressOfResidence"
                            value={customerDetailsObject?.address}
                            label={t("customerDetails.addressOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="cityOfResidence"
                            value={customerDetailsObject?.cityResidence?.code}
                            label={t("customerDetails.cityOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="postalCode"
                            value={customerDetailsObject?.postCode}
                            label={t("customerDetails.postalCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="province"
                            value={customerDetailsObject?.provinceResidence?.code}
                            label={t("customerDetails.province")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="countryOfResidence"
                            value={customerDetailsObject?.countryResidence?.description}
                            label={t("customerDetails.countryOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                {hasScope(THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL) &&
                                    <Button color={"accent"}
                                         onClick={() => {
                                             navigate(`/finessecurity/watchlist/addCustomer`, {
                                                 state: {
                                                     customer: customerDetailsObject
                                                 }
                                             });
                                         }}>
                                    {t("tabs.addToBlacklist")}
                                </Button>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default CustomerDetails;